export default __webpack_public_path__ + "static/media/1300.35aeb491.png";